import { CellContext } from "@tanstack/react-table";
import type { ViewTableFeatures } from "@design-system/ViewTable/core/table";
import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";
import { formatTokenDate } from "@helpers/date";
import type { McpCliTokenRow } from "../mcpCliTokensViewConfig";

export const TokenDateCell = memo(
    ({
        getValue,
    }: CellContext<
        ViewTableFeatures,
        McpCliTokenRow,
        string | Date | null
    >) => <ViewTableCell>{formatTokenDate(getValue())}</ViewTableCell>,
);
